<template src="../templates/normal_fcont_25.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrint from '../components/CreativePrint'

import { Carousel,Slide } from 'uiv'

import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import CreatorProfileItsuka from "../components/CreatorProfileItsuka"
import AppDownloadCreative from '../components/AppDownloadCreative';
export default {
  name: 'app',
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,FuncSearchGalleryQR,CreativePrint,
   CreatorProfileItsuka,AppDownloadCreative
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  methods: {
    trackGa4AppCreativeDownloadEvent: function() {
      this.$gtag.event("app_download", {
        "app_name": "Creative Print",
        "location_id": "article",
        "article_no": "25",
        "site_id": "gallery"
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['25-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['25-2']}
    ]};
  }
};
</script>
<style />


